import type { SortingState } from '@tanstack/react-table';

import type { TranslationKey } from '~/shared/internationalization/translation';
import type { TableColumnWidth } from '~/ui/core/table/Table';

export const TITLE_COLUMN_ID = 'title';
export const HIDEABLE_BASE_COLUMN_IDS = [
    'externalId',
    'updatedAt',
    'provider',
    'state',
    'ownerName',
    'createdAt',
] as const;
export type BaseColumnId = typeof TITLE_COLUMN_ID | (typeof HIDEABLE_BASE_COLUMN_IDS)[number];

const DEFAULT_COLUMN_WIDTH: TableColumnWidth = 'minmax(120px,0.7fr)';
export const COLUMN_WIDTHS: Readonly<Record<BaseColumnId, TableColumnWidth>> = {
    createdAt: DEFAULT_COLUMN_WIDTH,
    externalId: DEFAULT_COLUMN_WIDTH,
    ownerName: DEFAULT_COLUMN_WIDTH,
    provider: DEFAULT_COLUMN_WIDTH,
    state: DEFAULT_COLUMN_WIDTH,
    title: 'minmax(280px,1.6fr)',
    updatedAt: DEFAULT_COLUMN_WIDTH,
};
export const COLUMN_LABEL_KEYS: Readonly<Record<BaseColumnId, TranslationKey>> = {
    createdAt: 'pages.learning-opportunities.headlines.created',
    externalId: 'pages.learning-opportunities.headlines.external-id',
    ownerName: 'pages.learning-opportunities.headlines.owner',
    provider: 'pages.learning-opportunities.headlines.provider',
    state: 'pages.learning-opportunities.headlines.state',
    title: 'pages.learning-opportunities.headlines.title',
    updatedAt: 'pages.learning-opportunities.headlines.updated-at',
};

const isBaseColumnId = (columnId: string): columnId is BaseColumnId => columnId in COLUMN_WIDTHS;

export const getColumnWidth = (columnId: string): TableColumnWidth =>
    isBaseColumnId(columnId) ? COLUMN_WIDTHS[columnId] : DEFAULT_COLUMN_WIDTH;

export const customAttributeLabelKey = (attributeName: string): TranslationKey =>
    `attributes.learningOpportunity.${attributeName}`;

export const columnAriaSort = (sorting: SortingState, columnId: string): 'ascending' | 'descending' | 'none' => {
    const active = sorting.find((item) => item.id === columnId);

    if (active === undefined) return 'none';

    return active.desc ? 'descending' : 'ascending';
};
